// Shared Web Audio singleton + helpers
let _ctx = null;
export function getCtx() {
  if (!_ctx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    _ctx = new Ctx();
  }
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

// A pleasant bell-like tone with attack/release envelope
export function playTone(freq, duration = 1.2, type = "sine", gain = 0.3) {
  const ctx = getCtx();
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  const now = ctx.currentTime;
  g.gain.setValueAtTime(0, now);
  g.gain.linearRampToValueAtTime(gain, now + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, now + duration);
  osc.connect(g);
  g.connect(ctx.destination);
  osc.start(now);
  osc.stop(now + duration);
}

// Rich gong: low fundamental + harmonics + slight detune
export function playGong() {
  const ctx = getCtx();
  const now = ctx.currentTime;
  const fundamental = 80;
  const harmonics = [1, 1.5, 2.2, 3.1, 4.5, 6.3];
  harmonics.forEach((h, i) => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = i === 0 ? "sine" : "triangle";
    osc.frequency.value = fundamental * h * (1 + (Math.random() - 0.5) * 0.01);
    const peak = 0.4 / (i + 1);
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(peak, now + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, now + 4 + i * 0.3);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 4.5);
  });
}

// Singing bowl: sustained sine + 5th harmonic shimmer
export function playBowl(durationSec = 3) {
  const ctx = getCtx();
  const now = ctx.currentTime;
  const base = 320;
  [1, 2.76, 5.4].forEach((h, i) => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = base * h;
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(0.18 / (i + 1), now + 0.4);
    g.gain.linearRampToValueAtTime(0.12 / (i + 1), now + durationSec - 0.5);
    g.gain.exponentialRampToValueAtTime(0.0001, now + durationSec);
    // Slow tremolo
    const lfo = ctx.createOscillator();
    const lfoGain = ctx.createGain();
    lfo.frequency.value = 4 + i;
    lfoGain.gain.value = 0.01 * h;
    lfo.connect(lfoGain);
    lfoGain.connect(osc.frequency);
    lfo.start(now);
    lfo.stop(now + durationSec);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + durationSec);
  });
}
